export const standard = {
    path: '/standard',
    name: 'standard',
    title: ' 标准法规',
    component: () => import("../components/page/homePage/standard"),
    meta: { title: '标准法规' },
}


// WEBPACK FOOTER //
// ./src/router/standard.js